import React from 'react';
import PropTypes from 'prop-types';
import {
  Box, Typography, IconButton, Tooltip, Divider,
} from '@mui/material';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import {
  CardWrapper, SectionTitle, Field, FieldLabel, ButtonOutlined,
} from '../../UI';
import { HISTORICO } from '../../../mocks/processos.mock';
import * as C from '../../../theme/colors.constants';

/**
 * Aba Histórico.
 *
 * Duas colunas, como no print `grid_check_historico.png`: à esquerda o
 * formulário de lançamento (estreito), à direita a timeline de comentários.
 */
export default function AbaHistorico({ processo }) {
  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: 'minmax(0, 1fr)', lg: 'minmax(0, 0.62fr) minmax(0, 1.38fr)' },
        gap: 'clamp(10px, 0.8vw, 22px)',
        alignItems: 'start',
      }}
    >
      {/* --- Formulário de lançamento --- */}
      <CardWrapper>
        <SectionTitle>Histórico</SectionTitle>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
          <Field label="Cliente:" value={processo?.nomeCliente || ''} InputProps={{ readOnly: true }} />
          <Field label="Devedor:" value={processo?.nomeDevedor || ''} InputProps={{ readOnly: true }} />
          <Field label="Fase atual:" value={processo?.fase || ''} InputProps={{ readOnly: true }} />

          <Box>
            <FieldLabel>Responsável:</FieldLabel>
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <Box
                sx={{
                  width: 34,
                  height: 34,
                  borderRadius: '50%',
                  flexShrink: 0,
                  border: `1px solid ${C.borderGrey}`,
                  backgroundColor: C.paleGrey,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: 12,
                  fontWeight: 700,
                  color: C.navy,
                }}
              >
                {(processo?.negociador || '?').slice(0, 2).toUpperCase()}
              </Box>
              <ButtonOutlined size="small" sx={{ flex: 1 }}>ALTERAR NEGOCIADOR</ButtonOutlined>
            </Box>
          </Box>

          <Field
            label="Tipo de contato/Recado:"
            tipo="select"
            value="Contato com representante"
            options={['Contato com representante', 'Contato com o devedor', 'Recado', 'Sem contato']}
          />
          <Field label="Nome do contato:" />

          <Box sx={{ display: 'flex', gap: 1 }}>
            <Field label="DDD:" sx={{ width: 74, flexShrink: 0 }} />
            <Field label="Telefone:" />
          </Box>

          <Field
            label="Tipo de histórico:"
            tipo="select"
            value="Comentário"
            options={['Comentário', 'Agendamento', 'Promessa', 'Tarefa']}
          />
          <Field label="Texto:" placeholder="Inserir texto:" multiline minRows={4} />
          <ButtonOutlined>GRAVAR HISTÓRICO</ButtonOutlined>
        </Box>
      </CardWrapper>

      {/* --- Timeline --- */}
      <CardWrapper>
        <SectionTitle
          right={(
            <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
              <ButtonOutlined size="small">EXPANDIR</ButtonOutlined>
              <Tooltip title="Filtrar por período" arrow>
                <IconButton size="small" sx={{ color: C.navy }}>
                  <EventOutlinedIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        >
          Ocorrências
        </SectionTitle>

        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          {HISTORICO.map((h, i) => (
            <Box key={`${h.data}-${i}`}>
              <Box sx={{ display: 'flex', gap: 1.5, py: 1.25 }}>
                <Box
                  sx={{
                    width: 9,
                    height: 9,
                    borderRadius: '50%',
                    backgroundColor: C.navy,
                    mt: 0.75,
                    flexShrink: 0,
                  }}
                />
                <Box>
                  <Typography variant="body2">
                    <Box component="span" sx={{ fontWeight: 700 }}>Data: </Box>
                    {h.data}
                  </Typography>
                  <Typography variant="body2">
                    <Box component="span" sx={{ fontWeight: 700 }}>Autor: </Box>
                    {h.autor}
                  </Typography>
                  {h.comentarios ? (
                    <Typography variant="body2">
                      <Box component="span" sx={{ fontWeight: 700 }}>Comentários: </Box>
                      {h.comentarios}
                    </Typography>
                  ) : null}
                  {h.extra ? (
                    <Typography variant="body2" sx={{ color: C.warmGrey }}>{h.extra}</Typography>
                  ) : null}
                </Box>
              </Box>
              {i < HISTORICO.length - 1 ? <Divider /> : null}
            </Box>
          ))}
        </Box>
      </CardWrapper>
    </Box>
  );
}
AbaHistorico.propTypes = { processo: PropTypes.object };
AbaHistorico.defaultProps = { processo: null };
